<script lang="ts">
  /**
   * GridContent - Constrains content to align with the page grid lines.
   *
   * Grid lines are at 9.03% from viewport edges. This component ensures
   * content stays between those lines. Use this inside every section
   * so layout changes only need to happen here.
   *
   * For content that needs extra inset from the grid lines (like cards),
   * use the `inset` prop to add additional padding.
   */
  import type { Snippet } from 'svelte';

  interface Props {
    class?: string;
    /** Additional inset from grid lines (e.g., "54px" for card areas) */
    inset?: string;
    children?: Snippet;
  }

  let { class: className = '', inset, children }: Props = $props();
</script>

<div
  class="lg:mx-[9.03%] px-6 lg:px-0 {className}"
  style={inset ? `padding-left: ${inset}; padding-right: ${inset};` : undefined}
>
  {#if children}
    {@render children()}
  {/if}
</div>
